import { isSameDay } from '@utils/dates';
import { getTimeForDate } from '@utils/textHelper';

/* eslint-disable import/prefer-default-export */
export const sortingLogic = (events, goals) => {
  const eventsData = {};
  goals.forEach((goal) => {
    eventsData[goal] = events.filter((event) => event.goalKey === goal);
    const isLiveArr = [];
    let isCompletedArr = [];
    let isUpcomingArr = [];
    eventsData[goal].forEach((event) => {
      const startTimeDiff =
        new Date(getTimeForDate(event.startsAt, event.date)) - new Date();
      const endTimeDiff =
        new Date(getTimeForDate(event.endsAt, event.date)) - new Date();
      const isLive =
        isSameDay(new Date(event.date), new Date()) &&
        startTimeDiff < 1800000 &&
        endTimeDiff > 0;
      if (isLive) isLiveArr.push(event);
      if (startTimeDiff > 0 && !isLive) isUpcomingArr.push(event);
      if (endTimeDiff < 0) isCompletedArr.push(event);
    });
    isCompletedArr = isCompletedArr.sort((a, b) => {
      if (a.date === b.date) {
        return (
          new Date(getTimeForDate(b.startsAt, b.date)) -
          new Date(getTimeForDate(a.startsAt, a.date))
        );
      }
      return new Date(b.date) - new Date(a.date);
    });
    isUpcomingArr = isUpcomingArr.sort((a, b) => {
      if (a.date === b.date) {
        return (
          new Date(getTimeForDate(a.startsAt, a.date)) -
          new Date(getTimeForDate(b.startsAt, b.date))
        );
      }
      return new Date(a.date) - new Date(b.date);
    });
    eventsData[goal] = [...isLiveArr, ...isUpcomingArr, ...isCompletedArr];
  });
  return eventsData;
};
